export enum ROUTES {
    Main = "/",
    Tech = "/tech",
    Team = "/team",
    Contact = "/contact"
}
